import Model from "@/app/models/Concerns/Model";
import {AxiosResponse} from "axios";
import Client from "@/app/Http/Client";

export default class Employee extends Model {
    public isahId!: string;
    public name!: string;
    public firstName!: string;
    public lastName!: string;
    public user_id!: string;

    getTable(): string {
        return "employees";
    }
}